var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useEffect, useState } from "react";
import { defaultPagingRequest } from "./dynamicCatalogBuilder.entity";
import { setReducerState } from "../../../redux/crudSlice";
import { useAppSelector, useAppDispatch } from "../../../store/hooks";
import { cleanUpReducers } from "../../common/commonFunctions";
export default function useDynamicCatalog(props) {
    var _this = this;
    var _crud$pagingAPIKey, _crud$pagingAPIKey2;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = props.pagingAPIKey, pagingAPIKey = _a === void 0 ? '' : _a, pagingAPIRequest = props.pagingAPIRequest, getPagingData = props.getPagingData, _b = props.rows, rows = _b === void 0 ? (_crud$pagingAPIKey = crud[pagingAPIKey]) === null || _crud$pagingAPIKey === void 0 ? void 0 : _crud$pagingAPIKey.data : _b;
    var dispatch = useAppDispatch();
    var pagingUpdateKey = pagingAPIKey + 'Updated';
    var _c = useState(_objectSpread({}, defaultPagingRequest)), paging = _c[0], setPaging = _c[1];
    useEffect(function () {
        if (!rows) {
            getRows(paging);
        }
        return function () {
            cleanUpReducers([pagingAPIKey], dispatch);
        };
    }, []);
    useEffect(function () {
        if (crud[pagingUpdateKey]) {
            getRows(paging);
        }
    }, [crud[pagingUpdateKey]]);
    var getRows = function (_state) { return __awaiter(_this, void 0, void 0, function () {
        var _request, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _request = _objectSpread(_objectSpread({}, _state), pagingAPIRequest);
                    return [4 /*yield*/, (getPagingData === null || getPagingData === void 0 ? void 0 : getPagingData({
                            key: pagingAPIKey,
                            request: _request
                        }))];
                case 1:
                    res = _a.sent();
                    dispatch(setReducerState({
                        key: pagingUpdateKey,
                        value: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var onPageSizeChange = function (_ref) { return __awaiter(_this, void 0, void 0, function () {
        var page, pageSize, _state;
        return __generator(this, function (_a) {
            page = _ref.page, pageSize = _ref.pageSize;
            _state = _objectSpread(_objectSpread({}, paging), {}, {
                skip: page * pageSize,
                take: pageSize
            });
            getRows(_state);
            setPaging(_state);
            return [2 /*return*/];
        });
    }); };
    var onSortChange = function (sortModel) { return __awaiter(_this, void 0, void 0, function () {
        var _sortModel$0$field, _sortModel$, _sortModel$2, sortBy, _state;
        return __generator(this, function (_a) {
            sortBy = {
                orderby: (_sortModel$0$field = (_sortModel$ = sortModel[0]) === null || _sortModel$ === void 0 ? void 0 : _sortModel$.field) !== null && _sortModel$0$field !== void 0 ? _sortModel$0$field : defaultPagingRequest.orderby,
                asc: ((_sortModel$2 = sortModel[0]) === null || _sortModel$2 === void 0 ? void 0 : _sortModel$2.sort) === "asc" ? 1 : -1
            };
            _state = _objectSpread(_objectSpread({}, paging), sortBy);
            getRows(_state);
            setPaging(_state);
            return [2 /*return*/];
        });
    }); };
    var onFilterModelChange = function (searchModel) {
        var _searchModel$items$;
        var _search = (_searchModel$items$ = searchModel.items[0]) === null || _searchModel$items$ === void 0 ? void 0 : _searchModel$items$.value;
        var _state = _objectSpread(_objectSpread({}, paging), {}, {
            search: _search || null
        });
        getRows(_state);
        setPaging(_state);
    };
    return {
        rows: rows,
        paging: paging,
        setPaging: setPaging,
        getRows: getRows,
        onPageSizeChange: onPageSizeChange,
        onSortChange: onSortChange,
        onFilterModelChange: onFilterModelChange,
        count: (_crud$pagingAPIKey2 = crud[pagingAPIKey]) === null || _crud$pagingAPIKey2 === void 0 ? void 0 : _crud$pagingAPIKey2.count,
        loading: pagingAPIKey ? crud["isLoading".concat(pagingAPIKey)] === 'loading' : false
    };
}
